import * as $http from 'superagent';
import { forEach } from '../utils/collection';
import { isNotNullOrWhitespace } from '../utils';

export abstract class ApiClientBase {

    public get<TResponse = any>(url: string, withCredentials?: boolean) {
        return this.dispatchRequest<TResponse>($http.get(`${this.host}/${url}`), undefined, undefined, withCredentials);
    }

    public getWithQuery<TResponse = any>(url: string, query: any, withCredentials?: boolean) {
        return this.dispatchRequest<TResponse>($http.get(`${this.host}/${url}`), undefined, query, withCredentials);
    }

    public post<TResponse = any>(url: string, payload?: any, withCredentials?: boolean) {
        return this.dispatchRequest<TResponse>($http.post(`${this.host}/${url}`), payload, undefined, withCredentials);
    }

    public patch<TResponse = any>(url: string, payload: any) {
        return this.dispatchRequest<TResponse>($http.patch(`${this.host}/${url}`), payload);
    }

    public put<TResponse = any>(url: string, payload: any) {
        return this.dispatchRequest<TResponse>($http.put(`${this.host}/${url}`), payload);
    }

    public del<TResponse = any>(url: string) {
        return this.dispatchRequest<TResponse>($http.del(`${this.host}/${url}`));
    }

    public upload<TResponse = any>(url: string, files: File[], verb: 'post' | 'put' | 'patch' = 'post') {
        const formData = new FormData();
        forEach(files, (f, idx) => formData.append(`file-${idx!}`, f));
        switch(verb) {
            case 'post':
                return this.post<TResponse>(url, formData);
            case 'patch':
                return this.patch<TResponse>(url, formData);
            case 'put':
            default:
                return this.put<TResponse>(url, formData);
        }
    }

    public download(url: string) {
        const fullUrl = `${this.host}/${url}`;
        window.open(fullUrl, '_blank');
    }

    protected abstract acquireToken(): Promise<string>;
    protected failedRequestAction(resp: $http.Response): void {}
    protected successfulRequestAction(resp: $http.Response): void {}

    private dispatchRequest<TResponse>(req: $http.SuperAgentRequest, payload?: any, query?: any, withCredentials?: boolean): Promise<TResponse> {
        return this.acquireToken()
        .then(token => {
          if(isNotNullOrWhitespace(token)) {
            req.set('Authorization', `Bearer ${token}`);
          }

          if(withCredentials === true) {
            req.withCredentials();
          }

          if(!!payload) {
            req.send(payload);
          }

          if(!!query) {
              req.query(query);
          }
    
          // this forces the response handler to handle all server responses. Failures to contact the server will still be handled by
          // by the catch function
          req.ok(resp => true);
    
          return req
            .then(resp => this.responseHandler<TResponse>(resp))
            .catch(err => {
                const errorCode = isNaN(err) ? -1 : err; // -1 shall be understood to be a network failure
                return Promise.reject(errorCode);
            }); 
        });
    }

    private responseHandler<TResponse>(resp: $http.Response): Promise<TResponse> {
        if(Math.floor(resp.status / 100) !== 2) {
            this.failedRequestAction(resp);
            return Promise.reject(resp.status);
        }

        this.successfulRequestAction(resp);
        return Promise.resolve(resp.body) as Promise<TResponse>;
    }

    public host: string = '';
}